export default __webpack_public_path__ + "static/media/green-map-dot-viewed.774e5b2b.svg";